module.exports = __webpack_public_path__ + "static/selfie-c87fc6e6768c33d8484e513daf3d1987.jpg";